import React from 'react';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
} from '@mui/material';
import Divider from '@mui/material/Divider';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';

const OrgEditList = (props) => {

  const data = props.data ? props.data : []
  const handleEditClick = props.handleEditClick
  const handleDelete = props.handleDelete
  const showEdit = props.showEdit ? props.showEdit : false;
  const showDelete = props.showDelete ? props.showDelete : false;

  if (data.length === 0) {
    return <div></div>
  }

  //console.log(`data =${JSON.stringify(data)}`)
  return (

    <List>
      {data.map(( org ) => (
        <React.Fragment key={org.orgID + "-DUMMY"}>
          <ListItem key={org.orgID}>
            <ListItemText primary={org.orgName} secondary={org.orgEmail + " " + org.orgPhone} />
            <ListItemSecondaryAction>
              {showEdit &&
                <IconButton edge="end" aria-label="edit" onClick={() => handleEditClick(org)}>
                  <EditIcon />
                </IconButton>
              }
              {showDelete &&
              <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(org)}>
                <DeleteIcon />
              </IconButton>
              }
            </ListItemSecondaryAction>
          </ListItem>
          <Divider></Divider>
        </React.Fragment>
      ))}
    </List>


  );
};

export default OrgEditList;